<template>
  <vs-input
    :label="required ? `${label}*` : label"
    placeholder="4081 7810 1234 5678 9012"
    v-mask="'#### #### #### #### ####'"
    :value="value"
    name="account_number"
    v-bind="$attrs"
    v-on="inputListeners"
    v-validate="'required|regex:^4081 7810 [0-9]{4} [0-9]{4} [0-9]{4}$'"
    :danger="errors.has(errorsScope)"
    :danger-text="(
        value &&
        value.length == 24 &&
        !value.startsWith('4081 7')
      )
      ? 'Чаевые нельзя отправить на ИП или ООО, введите номер счета физического лица'
      : 'Номер счета должен начинаться с 4081 7810 и содержать не менее 20 цифр'"
  />
</template>

<script>
export default {
  name: 'InputAccountNumber',
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: 'Номер банковского счета'
    },
    required: {
      type: Boolean,
      default: true
    },
    errorsScope: {
      type: String,
      default: 'account-number'
    }
  },
  computed: {
    inputListeners() {
      return {
        ...this.$listeners
      }
    }
  }
}
</script>
